// components/CustomDayHeader.jsx
import React from 'react';
import moment from 'moment';

const CustomDayHeader = ({ label, date }) => {
  const day = moment(date).day(); // Sunday = 0, Monday = 1, ..., Saturday = 6

  let textColor = 'text-gray-600';
  if (day === 0) textColor = 'text-red-600';     // Sunday
  if (day === 6) textColor = 'text-blue-600';    // Saturday

  return (
    <div className={`text p-2 font-semibold text-center ${textColor}`}>
      {label}
    </div>
  );
};

export default CustomDayHeader;
